import { useState } from "react";

export default function AppTutorial() {
  const [run, setRun] = useState(false);

  const steps = [
    {
      target: ".price",
      content: "Aqui você acessa os produtos cadastrados."
    },
  ];

  return (
    // <Joyride
    //   steps={steps}
    //   run={run}
    //   continuous
    //   showSkipButton
    //   scrollToFirstStep
    // />
    <></>
  );
}
